import { createRoot } from 'react-dom/client'

import LCLegend from './LCLegend/LCLegend'

import './lclegend-control.styl'

class LCLegendControl {
  constructor(map) {
    this._container = null
    this._root = null
    this.map = map
  }

  onAdd() {
    this._container = document.createElement('div')
    this._container.className = `maplibregl-ctrl maplibregl-ctrl-group maplibregl-ctrl-lclegend`

    this._root = createRoot(this._container)
    this._root.render(<LCLegend />)

    return this._container
  }

  onRemove() {
    if (this._root) {
      queueMicrotask(() => {
        this._root.unmount()
      })
    }
    if (this._container?.parentNode) {
      this._container.parentNode.removeChild(this._container)
    }
  }
}

export default LCLegendControl
